import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import CustomInputLabel from "../customInputLabel";

const CustomInput = ({
  id,
  name,
  title,
  titleRequired = true,
  isRequired = true,
  value,
  onChange,
  type = "text",
  placeholder = "Enter value",
  required = false,
  helperText = "",
  width = "120px", // Default width
  adornmentValue = null, // String for adornment
  adornmentIcon = null, // Icon for adornment
  adornmentRequired = false, // Whether adornment is needed
  ...restProps
}) => {

  return (
    <>
      {titleRequired && (
        <CustomInputLabel title={title} isRequired={isRequired} />
      )}
      <TextField
        id={id}
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        fullWidth
        variant="outlined"
        sx={{
          width,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "lightgrey",
            },
            "&:hover fieldset": {
              borderColor: "#FF7C1B",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#FF7C1B",
            },
          },
        }}
        helperText={helperText}
        error={helperText.length > 0 ? true : false}
        InputProps={{
          startAdornment: adornmentRequired ? (
            <InputAdornment
              position="start"
              sx={{
                height: "100%",
                width: "40px",
                backgroundColor: "#E9ECEF",
                marginLeft: "-13px",
              }}
            >
              {adornmentIcon ? (
                adornmentIcon // Show icon if provided
              ) : (
                <div
                  style={{
                    width: "40px",
                    fontSize: "0.875rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {adornmentValue}
                </div>
              )}
            </InputAdornment>
          ) : null,
        }}
        {...restProps}
      />
    </>
  );
};

export default CustomInput;
